export function upcomingEvents(state) {
    return state.upcomingEvents;
}

export function eventDetails(state) {
    return state.eventDetails;
}

export function meetingJoined(state) {
    return state.meetingJoined;
}

export function dominantSpeaker(state) {
    return state.dominantSpeaker;
}

export function forceLeave(state) {
    return state.forceLeave;
}

export function ongoingSession(state) {
    return state.ongoingSession;
}

export function ongoingSessionID(state) {
    return state.ongoingSessionID;
}

export function eventSlotFirebase(state) {
    return state.eventSlotFirebase;
}

export function showAvSettingsModal(state) {
    return state.showAvSettingsModal
}

export function showTurboBridgeModal(state) {
    return state.showTurboBridgeModal
}

export function showSurveyPopupModal(state) {
    return state.showSurveyPopupModal
}

export function currentBandwidth(state) {
    return state.currentBandwidth
}

export function currentVideoSettings(state) {
    return state.currentVideoSettings
}

export function currentSessionJoinTime(state) {
    return state.currentSessionJoinTime
}